import { AnalyseConstants } from '../../../_constants';

const initialState = { team_id_group_list_loading: false, team_id_group_list_data: {}, team_id_group_list_error: false };

export function team_id_group_list(state = initialState, action) {

    switch (action.type) {
        case AnalyseConstants.REQUEST_TEAM_ID_GROUPS:
            return {
                team_id_group_list_loading: true,
                team_id_group_list_data: {},
                team_id_group_list_error: false
            };
        case AnalyseConstants.RECEIVE_TEAM_ID_GROUPS:
            return {
                team_id_group_list_loading: false,
                team_id_group_list_data: action.team_member_ids,
                team_id_group_list_error: false
            };
        case AnalyseConstants.TEAM_ID_GROUPS_ERROR:
            return {
                team_id_group_list_loading: false,
                team_id_group_list_data: {},
                team_id_group_list_error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/saveTeam/team_id_list_on_relation.reducer.js